var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarFemme1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 494 494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10{fill:none;}.cls-2{fill:#bfdbf7;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#2d3047;}.cls-5{fill:#fed766;}.cls-6{fill:#aa6396;}.cls-7{fill:#8c4f7e;}.cls-8{fill:#ff1d25;opacity:0.19;}.cls-9{fill:#66315e;}.cls-10{stroke:#606060;stroke-linecap:round;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246,
    cy: 247,
    r: 247
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MinDef_ILLU_vectorisation_v3_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5",
    "data-name": "Calque 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jeune_fille",
    "data-name": "Jeune fille"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 246,
    cy: 247,
    r: 247
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 311,
    cy: 281,
    r: 37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60,436c1-6.16,14-83,48-90,5.64-1.16,11.29-.3,36-3,13.37-1.46,21.19-2.75,30-4,30-4.25,45-6.28,63-6,29.79.46,53.42,7.48,65,11,6.11,1.86,13.95,6.4,27,10,15.78,4.36,20.48,3.16,27,6,11.67,5.09,18,18.24,25,47,10.85,44.63,21.45,90.91,4,150-2.27,7.68-3.4,11.52-5,15-32.71,71.23-203.44,112.84-283,31C42.44,546.88,56,461,60,436Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184,335a359.89,359.89,0,0,0-42,8,43.83,43.83,0,0,1-3,10,41.84,41.84,0,0,1-2,4c-2.88,5.15-3.16,34.43,17,59,23.95,29.18,59.17,33.39,65,34,2.79.29,45.3,4.12,79-26,6.75-6,23.07-21,29-46a81.49,81.49,0,0,0,2-24,233.78,233.78,0,0,0-65-20C231.37,329.05,204.89,332.29,184,335Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.81,269.74c-8.14,15.44,5.66,25.25-1.78,46.83-5.95,17.27-17.82,19.77-17.19,32.6.64,13.07,13.53,22.1,18.38,25.49,18.23,12.77,49.26,17.52,63.42,1.78,8.72-9.69,8.37-24.19,8.3-27.27-.28-11.76-5.08-13.47-6.52-24.89-2.36-18.73,9.37-23.52,7.7-39.12-1.46-13.75-12.66-29.74-29.63-33.79C227.11,247.22,208.66,256.77,201.81,269.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232,107c8.78-1.88,36.75-7.87,60.42,6.47l.86.53A94.37,94.37,0,0,1,320,140c4.61,6.62,6.18,10.54,7,13a33.55,33.55,0,0,1,1.88,8.26c.82,9.49-3.66,16.06-.88,41.74,1.79,16.58,3.71,14.32,4,24,0,1.26,0,3.1-.11,5.32-.31,6.79-1.6,29.71-14.89,51.68-6.83,11.3-17.66,29.19-39,36,0,0-30.57,9.73-63.6-11.93l-.6-.4c-1.71-1.14-3-2.08-3.8-2.67-4.68-3.43-13.17-10.39-24.6-28-25-38.43-38.72-64.12-32-96C162.18,139.19,202.4,113.34,232,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M287,204c2.31.66-7.05,18.1,1,35,3.86,8.1,9.85,12.16,8,17-1.63,4.26-8.09,5.88-12,6-1.12,0-7.87.38-11-4s-1.64-10.31,0-16C277.14,227.68,284.2,203.2,287,204Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.58,187a6.08,6.08,0,0,1-.94,6c-2.73,3.15-8.6.94-14.22,0-16.68-2.79-28.55,6.06-29.38,4-.72-1.79,8.18-8.8,19-12C247.38,182.22,261.12,181.45,263.58,187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.23,187a8.78,8.78,0,0,0,.61,6c1.75,3.15,5.54.94,9.17,0,10.77-2.78,18.43,6.06,19,4,.47-1.79-5.28-8.8-12.23-12C307.69,182.22,298.81,181.45,297.23,187Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 238.5,
    cy: 242,
    rx: 14.5,
    ry: 11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 314,
    cy: 240.83,
    rx: 10,
    ry: 9.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M324,125c18.63,23.94,14.37,54.09,13,62-7.27-1.76-17.55-4-30-6-13.82-2.2-24-3.82-37-4-16.55-.23-36.58-.27-56,11-8.16,4.74-13.87,8.05-17,15-8,17.76,8.93,41.49,6,43s-12.29-16.95-19-15c-3.77,1.1-5.58,8.32-5,14,1,9.45,8.36,13.61,14,21,4.95,6.49,10.13,17.53,9,37a131.91,131.91,0,0,1-20-16c-9.31-9.07-31.6-30.78-37-66-6.48-42.27,16-73.89,19-78,23.08-31.42,56-38.89,66-41C239.16,100.07,295.38,88.22,324,125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M247,211c0,2.62-2.78,4.57-5,5-3.3.64-7.13-1.71-9-6,2.31-3.2,5.87-4.78,9-4C244.05,206.51,247,208.31,247,211Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300,211c0,2.62,2.78,4.57,5,5,3.3.64,7.13-1.71,9-6-2.31-3.2-5.87-4.78-9-4C303,206.51,300,208.31,300,211Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M296,277a70,70,0,0,1-8-1c-5.84-1.07-6.64-2-10-2-4.36,0-5.26,1.51-10,2a25.67,25.67,0,0,1-10-1c.77,9.23,7.57,16.65,16,18C283.77,294.57,293.83,287.68,296,277Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 161,
    cy: 276,
    rx: 35,
    ry: 31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157,
    cy: 283,
    r: 37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140,342l-17,4a318.35,318.35,0,0,1,3,34c1.06,30.59-2.83,53.07-9,93-10.76,69.64-12.44,70.78-10,76,9.91,21.25,54.1,37.94,215,9,2.29-13.15,5.08-31.67,7-54,2.56-29.82,1.12-45.81,2-80,.42-16.33,1.41-40,4-69l-17-6c-1.51,11.19-3.67,27.79-6,48-5.25,45.5-4.62,50.79-8,57-20.73,38.06-137.07,11.31-151,8-.57-8.73-1.31-21.1-2-36-1.2-25.87-1.07-34.2-3-48A232.14,232.14,0,0,0,140,342Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M263,105a41.75,41.75,0,0,1,29,8c13.65,10.3,15.69,25.37,16,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M252.5,109.5a23.69,23.69,0,0,1,11,24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFemme1);
export default __webpack_public_path__ + "static/media/avatar_femme_1.c0b7c3495917b036de5d31b2fdeaa691.svg";
export { ForwardRef as ReactComponent };